import { render, staticRenderFns } from "./OrdersFiltersV2.vue?vue&type=template&id=e01a2472&scoped=true&"
import script from "./OrdersFiltersV2.vue?vue&type=script&lang=js&"
export * from "./OrdersFiltersV2.vue?vue&type=script&lang=js&"
import style0 from "./OrdersFiltersV2.vue?vue&type=style&index=0&id=e01a2472&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e01a2472",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VSpacer,VSwitch,VTooltip})
